// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title--2Sgvr","Calendar":"Calendar--3P_EW"};